import { atom } from "jotai";

interface MainState {
  searchRemittance: string;
  groupByCheck: boolean;
  isGroupByCheckManuallySet: boolean;
}

const initialState: MainState = {
  searchRemittance: "",
  groupByCheck: true,
  isGroupByCheckManuallySet: false,
};

export const mainAtom = atom<MainState>(initialState);

export const searchRemittanceAtom = atom(get => get(mainAtom).searchRemittance);
export const groupByCheckAtom = atom(get => get(mainAtom).groupByCheck);
export const isGroupByCheckManuallySetAtom = atom(get => get(mainAtom).isGroupByCheckManuallySet);
